export default __webpack_public_path__ + "static/media/Bracers of the Swift Talon.7ebd68a5.jpg";